import $ from 'jQuery';

$(function () {
    $('.alert__close').on('click', function () {
        let alert = $(this).parent();

        $(alert).addClass('dismiss');
        $(alert).slideToggle(500, function () {
            $(alert).remove();
        });
    });
});
